import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import { urlCdn, baseURL } from '../config/Env';

const headers = {
    common: {}
};

const apiToken = async (body, valida = false) => {
    const url = valida ? '/gestao/token/valida' : '/token',
        response = await axios
            .post(baseURL + url, body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });

    return response;
};

const api = axios.create({
    baseURL
});

const configureEnv = async (props = {}) => {
    let dsToken = await AsyncStorage.getItem('token');

    if (dsToken !== null) {
        headers.common.Authorization = dsToken;
        api.defaults.headers.common.Authorization = dsToken;

        if (props.onLogout) {
            api.onLogout = props.onLogout;
        }
    } else {
        dsToken = null;
        delete api.defaults.headers.common.Authorization;
        delete headers.common.Authorization;
        await AsyncStorage.clear();
    }
};

const deleteNotificacaoChave = (body) => {
    api({
        method: 'delete',
        url: '/gestao/notificacao-chave',
        data: body
    });
};

configureEnv();

api.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (!error.response) {
            // TODO usar o toast
            console.warn('Network error');
            return { errors: {} };
        }
        const { status = null, data = null } = error.response,
            { errors } = data;

        if (status === 401) {
            try {
                api.onLogout();
                window.location.reload();
                return Promise.reject(error);
            } catch (e) {
                window.location.reload();
            }
        } else if (errors) {
            // TODO usar o toast
            console.warn(errors[0].message);
            throw errors;
        }
        return error.response;
    }
);

export { headers, configureEnv, apiToken, deleteNotificacaoChave, urlCdn };
export default api;
